exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ApplePayButton_component_3r35 {}\n\n.ApplePayButton_button_1dt7 {\n  -webkit-appearance: -apple-pay-button;\n\n  display: inline-block;\n\n  width: 100%;\n  min-width: 180px;\n  height: 40px;\n\n  border-radius: 5px;\n\n  cursor: pointer\n}\n\n.ApplePayButton_button_1dt7:disabled {\n  opacity: 0.5;\n}\n\n.ApplePayButton_legal_1hkh {\n  margin-top: 10px;\n\n  font-family: Arial;\n  font-size: 13px;\n  font-style: italic;\n\n  color: #787878;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ApplePayButton_component_3r35",
	"button": "ApplePayButton_button_1dt7",
	"legal": "ApplePayButton_legal_1hkh"
};